import React, { useState } from 'react'
import Human from '../assets/user.png'
import DashboardHeader from '../components/DashboardHeader.js'
import Footer from '../components/Footer.js'
import { useAuth } from '../context/AuthContext.js'
import UpdateProfileModal from '../components/UpdateProfileModal.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Profile = () => {
    const {user, logout} = useAuth()

    const [editModalOpen, setEditModaOpen] = useState(false);

    const openEditModal = () => setEditModaOpen(true);
        
    const closeEditModal = () => setEditModaOpen(false);
    


    function handleLogout(params) {
        logout()
    }

    function newFeature() {
        toast.success('New Feature coming soon...', {
                position: "top-right",
                autoClose: 2000
            });
    }
    
  return (
    
     <div className='dashboard-container'>

   
      <UpdateProfileModal isOpen={editModalOpen} onClose={closeEditModal} />
        <ToastContainer />
      <section className="user-overview margin-top2">
              <div className="user-info">
                  <div className="profile-picture-container">
                      <img id="profile-picture" src={Human} alt="human_image" className="profile-picture" />
                  </div>
                  <div className="user-details">
                      <h2 className='profile-h2' id="username">{user.name}</h2>
                      <p className='profile-p' id="phone"><strong>Phone:</strong> {user.phone}</p>
                      <p className='profile-p' id="email"><strong>Email:</strong>{user.email}</p>
                      <p className='profile-p'><strong>User Type:</strong> <span id="user-type">{user.role}</span></p>
                      <p className='profile-p'><strong>Upload Document For Kyc:</strong> <span id="user-type" onClick={newFeature} className='upload-document2'>Upload</span></p>
                      <p className='profile-p'><strong>Kyc Verification:</strong> <span id="user-type">{user.status ? 'Completed' : 'Not Completed'}</span></p>
                      <button className="edit-profile-btn" onClick={openEditModal}>Edit Profile</button>
                      <button onClick={handleLogout} className="logout-btn">Sign Out</button>
                  </div>
              </div>
          </section>

  </div>
  )
}

export default Profile